'use strict';

angular.module('imagetrend.components')
    .controller('InspectionsSchedule', ['$scope', 'IPVisits', '$state', '$rootScope', '$uibModal', 'DocumentTypes', 'Documents', 'Upload', '$q', function ($scope, IPVisits, $state, $rootScope, $uibModal, DocumentTypes, Documents, Upload, $q) {
        $scope.portal = $state.current.data.isPortal;
        $scope.loading = true;
        $scope.creating = false;
        $scope.visit = {};
        $scope.visit.inspectors = [];
        $scope.visit.vehicles = [];
        $scope.group = [ ];

        if ($scope.portal) {
            if ($rootScope.enterprise && $rootScope.enterprise.website) {
                $scope.portalURL = $rootScope.enterprise.website;
            } else {
                $scope.portalURL = $rootScope.portalURL;
            }
        } else {
            if ($rootScope.enterprise && $rootScope.enterprise.site_location) {
                $scope.portalURL = $rootScope.enterprise.site_location;
            } else {
                $scope.portalURL = $rootScope.internalURL;
            }
        }

        DocumentTypes.getOtherDocuments().then(function (otherTypes) {
            $scope.DocumentTypes = otherTypes;
        });

        $scope.save = function (visit) {
            $scope.creating = true;
            $scope.messages = [];
            var documents = [];
            var pass = true;

            for (var i = 0; i < $scope.group.length; i++) {
                if ($scope.group[i].fileUpload.file_name === undefined || $scope.group[i].fileUpload.file_name === '') {
                    $scope.messages.push("Document " + (i + 1) + " is missing a required file");
                    pass = false;
                    $scope.creating = false;
                    break;
                }
                documents.push($scope.group[i].fileUpload);
            }
            if (pass) {

                visit.Date_Time_Set = (visit.inspection_date_time != null)
                visit.inspections = [];
                if (visit.service != null) {
                    visit.service_id = visit.service.id;

                    if (visit.service_template != null) {
                        visit.inspections.push({ service_id: visit.service.id, type: 'service' });
                    }
                    visit.vehicles.forEach(function (vehicle) {
                        visit.inspections.push({ vehicle_id: vehicle.id, service_id: visit.service.id, type: 'vehicle' });
                    })
                }

                IPVisits.save(visit).then(function (visit) {

                    var inspectionID = visit.inspections[0].id;
                    var docPromises = [];

                    // Save Document to Inspection Visit
                    if (documents != null) {
                        documents.forEach(function (document) {
                            document.data_object_id = 'E5A495F9-D340-4AEA-B6E3-2DD5D2190241'; // Data_Object_ID for Inspections
                            var docName = (document.document_name !== null && document.document_name !== '') ? document.document_name : document.file_name;
                            if (document.storage_uploaded && document.uploaded_document_id != null) {
                                var documentID = document.uploaded_document_id;
                                var dataObjectID = document.data_object_id;
                                docPromises.push(
                                    Documents.updateDocument(documentID, {
                                        name: docName,
                                        description: document.document_description,
                                        document_type_id: document.document_type,
                                        code: document.document_code
                                    }).then(function () {
                                        return Documents.createDocumentObject(documentID, inspectionID, dataObjectID);
                                    })
                                );
                            } else {
                                docPromises.push(
                                    Documents.upload({
                                        file: Upload.dataUrltoBlob(document.file_content, document.file_name),
                                        name: docName,
                                        description: document.document_description,
                                        document_type_id: document.document_type,
                                        data_object_id: document.data_object_id,
                                    }, inspectionID)
                                );
                            }
                        })
                    }

                    $q.all(docPromises).then(function () {
                        if ($scope.portal) {
                            $state.go('portal.menus.visit', { id: visit.id, visit: visit });
                        }
                        else {
                            $state.go('internal.inspecting.visit', { id: visit.id, visit: visit });
                        }
                    }).catch(function () {
                        $scope.messages = $scope.messages || [];
                        $scope.messages.push("There was a problem saving one or more documents. Please try again.");
                    }).finally(function () {
                        $scope.creating = false;
                    });
                });
            }
        }

        $scope.addInspector = function (visit) {
            if (visit.inspector != null) {
                visit.inspectors.push(angular.copy(visit.inspector));
                visit.inspector = null;
                visit.newInspector = false;
            }
        }

        $scope.removeInspector = function (array, item) {
            array.splice(array.indexOf(item), 1);
        }

        $scope.setInspectionTime = function (time) {
            if (time != null && isValidDate(time)) {
                if ($scope.visit.inspection_date == null) {
                    $scope.visit.inspection_date = new Date();
                }
                $scope.visit.inspection_date.setHours(time.getHours());
                $scope.visit.inspection_date.setMinutes(time.getMinutes());
            }
        };

        $scope.addGroup = function (group) {
            var doc = {};
            doc.fileUpload = {};
            doc.fileUpload.document_id = guid();
            doc.fileUpload.document_name = null;
            doc.fileUpload.document_description = null;
            doc.edit = true;
            doc.added = true;
            doc.sort_order = group.length + 1;
            group.push(doc);
        }

        $scope.removeGroup = function (group, index, doc) {
            $uibModal.open({
                animation: true,
                templateUrl: 'templates/confirm/confirm.html',
                controller: 'ConfirmModalController',
                resolve: {
                    message: function () {
                        
                        return "Are you sure you would like to remove this document?";
                    }
                }
            }).result.then(function (result) {
                if (result) {

                    if (index == null) {
                        updateArray(group, doc, result);
                    }
                    else {
                        group[index].doc = {};
                        group.splice(index, 1);
                    }
                }
            });
        }

        $scope.closeGroup = function (doc) {
            $scope.messages = [];
            var hasFile = doc.fileUpload.file_content !== undefined || doc.fileUpload.storage_uploaded === true;
            if (doc !== null && doc.fileUpload.document_id !== undefined && hasFile && doc.fileUpload.document_type !== undefined) {
                doc.edit = false;
                doc.changed = true;
            } else {
                if (!hasFile) $scope.messages.push("An uploaded file is required for an inspection document."); // missing file
                if (!(doc.fileUpload.document_type !== undefined && doc.fileUpload.document_type !== "")) $scope.messages.push("A document type is required for an inspection document."); // missing type
                if (doc.fileUpload.document_id === null || doc.fileUpload.id === "") $scope.messages.push("Something went wrong, try again later."); // something else
            }
        }

        // Open Modal for Upload
        $scope.openDocumentModal = function (fileUpload, document) {
            $uibModal.open({
                animation: true,
                templateUrl: 'templates/file-upload/file-upload-modal.html',
                controller: 'FileUploadModalController',
                resolve: {
                    file_content: function () {
                        return fileUpload.file_content;
                    },
                    file_upload_existing_docs: function () {
                        if ($scope.question) {
                            return $scope.question.file_upload_existing_docs;
                        }
                        return false;
                    },
                    question_id: function () {
                        if ($scope.question) {
                            return $scope.question.id;
                        }
                        return null;
                    },
                    parameters: function () {
                        return $scope.parameters;
                    }
                }
            }).result.then(function (upload) {
                if (upload != null) {
                    if (upload.is_new_upload && upload.document_id != null) {
                        // File was already uploaded directly to blob storage via chunked upload.
                        fileUpload.uploaded_document_id = upload.document_id;
                        fileUpload.document_code = upload.document_code;
                        fileUpload.file_name = upload.file_name;
                        fileUpload.file_content = null;
                        fileUpload.file_updated = true;
                        fileUpload.storage_uploaded = true;
                        document.fileUpload = fileUpload;
                    }
                    else if (upload.document_id != null) {
                        Documents.getByID(upload.document_id).then(function (file) {
                            fileUpload.file_name = file.file_name;
                            fileUpload.document_name = file.name;
                            fileUpload.uploaded_document_id = file.id;
                            fileUpload.document_code = file.code;
                            fileUpload.document_type = file.document_type_id;
                            fileUpload.document_description = file.description;
                            fileUpload.storage_uploaded = true;
                            document.fileUpload = fileUpload;
                        });
                    }
                    else {
                        fileUpload.file_content = upload.file_content;
                        fileUpload.file_name = upload.file_name;
                        fileUpload.storage_uploaded = false;
                        document.fileUpload = fileUpload;
                    }
                }
            });
        }

        $scope.setEdit = function (doc) {
            if (doc.fileUpload.document_id != null) {
                doc.edit = !doc.edit;
            }
        }
    }])
;